import React from 'react';
import { IonButton } from '@ionic/react';
import { useSwiper } from 'swiper/react';
import { useIsNative } from '../utils/useIsNative';
import { WelcomeSlide } from './WelcomeSlide';
import { SlideHeading } from './SlideHeading';
import { SlideActions } from './SlideActions';
import { SlideButton } from './SlideButton';

export const NOTE_SUMMARIES_SLIDE_HEADING = 'Instant Note Summaries';

export const NoteSummariesSlide: React.FC = () => {
    const swiper = useSwiper();
    const isNative = useIsNative();

    return (
        <WelcomeSlide image="2-notes.webp">
            <SlideHeading
                title={NOTE_SUMMARIES_SLIDE_HEADING}
                description={<>No scribbling, just <b>tap record</b>.<br/>Get automatic highlights and next steps<br/>— easy-to-read and ready to share.</>}
            />
            <SlideActions>
                {!isNative &&
                    <IonButton fill="clear" type="button" onClick={() => swiper.slidePrev()}>&lt; Back</IonButton>
                }
                <SlideButton onClick={() => swiper.slideNext()}>Sounds easy!</SlideButton>
            </SlideActions>
        </WelcomeSlide>
    );
};
